/* eslint-disable */
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import App from './components/App/App.vue';
import Router from 'vue-router'
import store from './store';
import router from './routes';
import './assets/scss/app.scss';
import {sync} from 'vuex-router-sync';
import VueI18n from 'vue-i18n'
import messages from './i18n/messages'
import CustomFilters from './filters';
import CustomDirectives from './directives';
import VueMoment from 'vue-moment';
import ShortNumber from './prototypes/short-number';
import VueMask from 'v-mask';
import VueProgressBar from 'vue-progressbar'
import Languages from './i18n/languages';
import LanguageService from './services/LanguageService';
import Rollbar from 'vue-rollbar';
import RollbarOptions from './rollbar';
import VueAnalytics from 'vue-analytics';

// Register vue handlers
Vue.config.errorHandler = (err, vm, info) => {
    if (Vue.rollbar !== 'undefined') {
        Vue.rollbar.error(err + '\n\n' + info + '\n\n');
    }
    console.error(err + '\n\n' + info + '\n\n')
};
Vue.config.warnHandler = (msg, vm, trace) => {
    if (Vue.rollbar !== 'undefined') {
        Vue.rollbar.warning(msg + '\n\n' + trace + '\n\n');
    }
    console.warn(msg + '\n\n' + trace + '\n\n')
};

Vue.use(Rollbar, RollbarOptions);
Vue.use(Router);
Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(CustomFilters);
Vue.use(CustomDirectives);
Vue.use(VueMoment);
Vue.use(ShortNumber);
Vue.use(VueMask);
Vue.use(VueProgressBar, {
    color: '#ffffff',
    failedColor: '#D95A4B',
});

// Google Analytics
Vue.use(VueAnalytics, {
    id: 'UA-123342655-1',
    debug: {
        enabled: process.env.NODE_ENV !== 'production',
        sendHitTask: process.env.NODE_ENV === 'production'
    },
    router
});

const i18n = new VueI18n({
    locale: LanguageService.getLanguageFromStorage() || 'en',
    fallbackLocale: 'en',
    silentTranslationWarn: process.env.NODE_ENV === 'production',
    messages
});

Vue.prototype.$locale = {
    change (language) {
        let msg = {success: true, text: 'Language changed'};
        if (i18n.messages[language].valid) {
            i18n.locale = language;
            LanguageService.setLanguageInStorage(language);
        } else {
            msg = {success: false, text: 'Translations missing, displaying default language'};
            LanguageService.setLanguageInStorage(i18n.fallbackLocale);
        }
        return msg;
    },
    current () {
        return i18n.locale;
    },
    getValidLanguages() {
        let languages = [];
        // Only return valid languages
        for(let language in i18n.messages) {
            if (i18n.messages[language].valid) {
                languages.push({value: language, name: Languages[language]})
            }
        }
        return languages;
    }
};

sync(store, router);

const app = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
});

export default app;



// WEBPACK FOOTER //
// ./src/app.js